import { createFileRoute } from "@tanstack/react-router";

import { LegalPage } from "@/components/legal/LegalPage";
import privacySource from "@/content/privacy.md?raw";

export const Route = createFileRoute("/privacy")({
  component: () => <LegalPage title="Privacy Policy" source={privacySource} />,
});
